<template>
  <div class="schedule-staff-list">
    <table>
      <template v-if="dates.length > 0">
        <tr class="row flex header">
          <!-- ヘッダー -->
          <td v-if="messageAddresses.length > 0" class="empty-cell user-name-col"></td>
          <td class="date-col" v-for="date in dates" :key="date">
            {{ formatDateWithDay(date) }}
          </td>
          <td class="remark-col">備考</td>
        </tr>
      </template>
      <template v-for="messageAddress in messageAddresses" :key="messageAddress.user">
        <tr class="row flex body">
          <el-tooltip
            effect="dark"
            :content="`${messageAddress.department_name} ${messageAddress.section_name} ${messageAddress.user_name}`"
            placement="top"
          >
            <td class="user-name-col align-middle">
              <text-omit
                :text="`${messageAddress.department_name} ${messageAddress.section_name} ${messageAddress.user_name}`"
              />
            </td>
          </el-tooltip>
          <td class="date-col" v-for="date in dates" :key="date"></td>
          <td class="remark-col" v-if="dates.length > 0"></td>
        </tr>
      </template>
    </table>
  </div>
</template>
<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { MessageAddress } from '@/api'
import TextOmit from '@/components/displays/TextOmit.vue'
import { formatDateWithDay } from '@/services/date'

/**
 * 日程(候補日)選択グループ
 */
export default defineComponent({
  name: 'ScheduleStaffListGroup',
  components: {
    TextOmit,
  },
  props: {
    // 日付一覧
    dates: {
      type: Array as PropType<string[]>,
      required: true,
    },
    // 宛先一覧
    messageAddresses: {
      type: Array as PropType<MessageAddress[]>,
      required: true,
    },
  },
  setup() {
    return {
      formatDateWithDay,
    }
  },
})
</script>

<style lang="scss" scoped>
.schedule-staff-list {
  width: 100%;
  overflow-x: auto;
}

td,
td {
  flex-shrink: 0;
  border: 1px solid;
  border-color: #ebeef5;
  border-radius: 0;
}
.user-name-col {
  padding-left: 10px;
  width: 200px;
  /** 固定させる */
  position: sticky;
  left: 0;
  background: #fff;
  /** スクロールした際に若干ずれるため指定 */
  margin-left: -2px;
  &:before {
    content: '';
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
  }
}
.remark-col {
  width: 100px;
}
</style>
